import type { ProductData } from '@/gql/reviews'

export function getProductCategoryLabels(product: ProductData, mainCategoryLabel: string): string[] {
  const categories = product.categories
    .filter((category) => category.published && !category.hidden && category.id !== product.mainCategory.id)
    .map((category) => category.title)
  return [`${product.mainCategory.title} (${mainCategoryLabel})`, ...categories]
}
